import { ServicePlan, SoftwareItem, Branch } from '../types';
import { IMG, CONTACT } from './constants';

export const SERVICE_PLANS: ServicePlan[] = [
  {
    title: 'Basic Plan',
    description: 'For small businesses with 1–3 barcode devices.',
    image: IMG.planBasic,
    popular: false,
    features: ['2 preventive maintenance visits/year', 'Remote support', '48-hr on-site response', '1 printer / 2 scanners covered'],
  },
  {
    title: 'Standard Plan',
    description: 'For growing businesses with 4–10 devices.',
    image: IMG.planStandard,
    popular: true,
    features: ['4 preventive maintenance visits/year', 'Remote + on-site support', '24-hr on-site response', 'Up to 5 printers / 10 scanners', 'Spare parts at discounted rate'],
  },
  {
    title: 'Enterprise Plan',
    description: 'For large operations with 10+ barcode devices.',
    image: IMG.planEnterprise,
    popular: false,
    features: ['Monthly maintenance visits', 'Same-day emergency response', 'Dedicated technician assigned', 'Unlimited devices covered', 'Free spare parts included', '24/7 helpline'],
  },
];

export const SOFTWARE_LIST: SoftwareItem[] = [
  {
    badge: 'Label Design Software',
    title: 'BarTender by Seagull Scientific',
    description: "The world's most powerful label design and printing software used by thousands of businesses globally.",
    points: ['Design labels, barcodes, QR codes and RFID tags', 'Connect to databases and ERP systems', 'Supports all barcode types (1D, 2D, QR, GS1)', 'Multiple printer support'],
    image: IMG.bartender,
    ctaText: 'Enquire for License →',
  },
  {
    badge: 'Free Label Software',
    title: 'ZebraDesigner / TSC Console',
    description: 'Free label design software bundled with Zebra and TSC printers. Perfect for small businesses.',
    points: ['Free to download and use', 'Supports all Zebra and TSC printers', 'Basic label design and barcode creation', 'Free technical support from our team'],
    image: IMG.zebraDesign,
    ctaText: 'Get Setup Help →',
  },
  {
    badge: 'Retail POS Software',
    title: 'Retail Billing & POS Software',
    description: 'Complete GST-compliant billing software for retail shops, supermarkets and stores.',
    points: ['GST-compliant billing and invoicing', 'Inventory management with barcode scanning', 'Sales reports and analytics dashboard', 'Cloud backup and data security'],
    image: IMG.posSoftware,
    ctaText: 'Get Free Demo →',
  },
  {
    badge: 'Jewellery Software',
    title: 'Jewellery Management Software',
    description: 'Specialized billing and inventory software for gold, silver and diamond jewellery stores.',
    points: ['Gold rate and making charge management', 'Barcode jewellery tag printing', 'GST billing and e-invoice generation', 'Old gold / exchange management'],
    image: IMG.jewSoftware,
    ctaText: 'Get Free Demo →',
  },
];

export const BRANCHES: Branch[] = [
  {
    name: 'Dehradun — Head Office',
    image: IMG.branch1,
    isHQ: true,
    address: CONTACT.address,
    phone: [CONTACT.phone1, CONTACT.phone2],
    email: CONTACT.email,
    whatsapp: CONTACT.whatsapp,
    hours: 'Mon–Sat: 9:30 AM – 6:30 PM',
  },
  {
    name: '[City Name] — Branch',
    image: IMG.branch2,
    isHQ: false,
    address: '[Full Street Address], [City], Uttarakhand – [PIN Code]',
    phone: ['+91 XXXX-XXXXXX'],
    email: 'branch2@devbhoomilabels.com',
    whatsapp: CONTACT.whatsapp,
    hours: 'Mon–Sat: 9:30 AM – 6:30 PM',
  },
];
